export default "/assets/images/app-showcase-04-sm.jpg?72028ac87310a2998b880b695926ddd3";